import React, {useEffect, useRef, useState} from "react";
import {classNames} from "shared/lib/classNames/classNames";
import {ReactComponent as Logo} from "shared/assets/icons/LigalTimesLogo.svg";
//import {AppLink} from "shared/ui/AppLink/AppLink";
import cls from "./Header.module.scss";
import {AppLink} from "shared/ui/AppLink/AppLink";


interface HeaderProps {
    className?: string
}

export const Header = ({className}: HeaderProps) => {
    const [headerOpen, setHeaderOpen] = useState(false);

    const menuRef = useRef(null);

    const closeMenu = (e: any) => {
        if (e.target === menuRef.current) {
            setHeaderOpen((prevState) => !prevState);
            document.body.classList.toggle("with-open-menu");
        }
    }

    const onToggleMenu = (e: any) => {
        setHeaderOpen((prevState) => !prevState);
        document.body.classList.toggle("with-open-menu");
    }

    // useEffect(() => {
    //     if (headerOpen && menuRef.current) {
    //         menuRef?.current.addEventListener("click", closeMenu);
    //     }
    //     return () => menuRef?.current.removeEventListener("click", closeMenu);
    // }, [headerOpen]);


    return (
        <header ref={menuRef} className={classNames(cls.header, {[cls.header_open]: headerOpen}, [className])}>
            <div className={classNames("container container__main", {}, [cls.header__container])}>
                <div className={cls.header__logo}>
                    <AppLink href={"/"}>
                        <div className={cls.Logo}>
                            <Logo width={50} height={50} fill={"#FF7A00"} />
                        </div>
                    </AppLink>
                </div>
                <nav className={classNames(cls.mainMenu, {}, [cls.header__menu])}>
                    <li className={cls.mainMenu__item}>
                        <AppLink href={"/"}>
                            Home
                        </AppLink>
                    </li>
                    <li className={cls.mainMenu__item}>
                        <AppLink href={"/about"}>
                            About Us
                        </AppLink>
                    </li>
                    <li className={cls.mainMenu__item}>
                        <AppLink href={"/terms"}>
                            Terms & Conditions
                        </AppLink>
                    </li>
                    <li className={cls.mainMenu__item}>
                        <AppLink href={"/policy"}>
                            Privacy Policy
                        </AppLink>
                    </li>

                </nav>
            </div>
        </header>
    );
};
